export const MODAL_NAMES = {
  EXTERNAL_REVIEW: "EXTERNAL_REVIEW",
  ADD_USER_MODAL: "ADD_USER_MODAL",
};

export const MODAL_SEARCH_PARAM_NAME = "modal";
